<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="_fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/organization";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          title: "集團資訊",
          floors: [
            {
              fields: [
                "locales",
                "organization",
                "remark",
                "administrator_name",
                "administrator_email",
                "administrator_password",
              ],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: ["industry_categories", "app"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "開通設定",
              remark: "停用的內容將不會顯示於使用者前台介面",
              fields: ["status"],
            },
          ],
        },
      ],
    },
  }),
  computed: {
    _fields() {
      let _fields = this.fields;
      delete _fields.administrator_password.rules;
      _fields.administrator_password.placeholder = "若無變更密碼則不需填寫此欄";
      return _fields;
    },
  },
};
</script>